import { get, sync } from 'vuex-pathify';
export default {
  computed: {
    tableHeight: sync('table/tableHeight'),
    tableRowHeightUserSetting: get('users/currentUser@settings.attribute_table_row_height'),
    isTableVisible() {
      return this.tableHeight > 0;
    },
    isIncreaseTableHeightButtonDisabled() {
      return this.tableHeight === 3;
    },
    isDecreaseTableHeightButtonDisabled() {
      return this.tableHeight === 0;
    },
    increaseTableHeightButton() {
      return {
        name: 'increaseTableHeight',
        icon: 'mdi-chevron-up',
        disabled: this.isIncreaseTableHeightButtonDisabled,
        tooltip: this.isIncreaseTableHeightButtonDisabled
          ? this.$i18n.t('button.increaseTableDisabled')
          : this.$i18n.t('button.increaseTable'),
        buttonSize: 'small',
      };
    },
    decreaseTableHeightButton() {
      return {
        name: 'decreaseTableHeight',
        icon: 'mdi-chevron-down',
        disabled: this.isDecreaseTableHeightButtonDisabled,
        tooltip: this.isDecreaseTableHeightButtonDisabled
          ? this.$i18n.t('button.decreaseTableDisabled')
          : this.$i18n.t('button.decreaseTable'),
        classes: 'mr-3',
        buttonSize: 'small',
      };
    },
  },
  methods: {
    increaseTableHeightAction() {
      if (this.tableHeight < 3) {
        this.tableHeight++;
      }
    },
    decreaseTableHeightAction() {
      if (this.tableHeight > 0) {
        this.tableHeight--;
      }
    },
  },
};
